import db from "../../database";
import store from "../../store/index";
import moment from "moment";
// import * as helper from "../../helper";
import printer from "../printer-offline";
import * as msg from "../../message";

export const invoiceHistory = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Invoice History");
    let response = {
      data: {},
    };

    if (store.state.system.isOffline == false) {
      return Promise.resolve(response);
    }

    let invoiceList = [];
    // let invoiceDet = "";
    let totalOrders = 0;
    let perPage = 10;

    db.transaction(
      "rw",
      db.invoice,
      db.payment,
      db.order,
      db.customer,
      db.cart,
      async () => {
        if (data.transaction_sub_type == "hold") {
          await db.order
            .orderBy("id")
            .reverse()
            .and((filter) => {
              return filter.status == "hold";
            })
            .each(async (order) => {
              let invoiceId = "";
              let invoice_data = {};
              // let mopList = [];
              let customerId = 0;
              let total = 0;
              let qty = 0;

              invoiceId = JSON.parse(order.cart_id);
              invoice_data.OD_ID = order.id;
              await db.cart
                .where("id")
                .anyOf(invoiceId)
                .each((item) => {
                  total += parseFloat(item.total);
                  invoice_data.Order_ID = order.order_id;
                  invoice_data.V_ID = item.v_id;
                  invoice_data.Date = item.date;
                  invoice_data.Cloud_Date = moment(
                    item.date + " " + item.time
                  ).format("DD MMM YYYY HH:mm A");
                  invoice_data.Transaction_Sub_Type = "hold";
                  invoice_data.Transaction_Type = "hold";
                  invoice_data.Status = "hold";
                  invoice_data.Store_ID = item.store_id;
                  invoice_data.Store_Name =
                    store.state.system.settings.store.name;
                  invoice_data.Location =
                    store.state.system.settings.store.location;
                  qty += item.weight_flag == true ? 1 : parseInt(item.qty);
                  // paymentId = JSON.parse(item.payment_id);
                  customerId = item.user_id;
                });
              if (
                customerId !=
                parseInt(store.state.billing.billing.dumuy_customer.c_id)
              ) {
                await db.customer.get(customerId, (customer) => {
                  if (customer != undefined) {
                    invoice_data.Customer_Name =
                      customer.first_name + " " + customer.last_name;
                    invoice_data.mobile = customer.mobile;
                  }
                });
              }
              invoice_data.Amount = total.toFixed(2);
              invoice_data.Qty = qty;
              invoiceList.push(invoice_data);
            });
        } else {
          // let last_id = 0;
          // await db.order
          //   .orderBy("id")
          //   .reverse()
          //   .first((item) => {
          //     last_id = item.id;
          //   });
          // if (data.page == 1) last_id += 1;
          // else if (data.page > 1) last_id -= data.page * perPage - perPage;
          // console.log(data.page * perPage - perPage);
          // console.log(last_id);

          totalOrders = await db.order
            .where("status")
            .equals("success")
            .count();

          let offset = 0;
          if (data.page > 1) offset = perPage * (data.page - 1);

          await db.order
            .orderBy("id")
            .and((filter) => {
              return filter.status == "success";
            })
            .offset(offset)
            .limit(perPage)
            .reverse()
            .each(async (order) => {
              let invoiceId = "";
              let invoice_data = {};
              let paymentId = [];
              let mopList = [];
              let customerId = 0;
              let total = 0;
              let qty = 0;

              invoiceId = JSON.parse(order.cart_id);
              invoice_data.OD_ID = order.id;
              await db.invoice
                .where("id")
                .anyOf(invoiceId)
                .each((item) => {
                  total += parseFloat(item.total);
                  invoice_data.Order_ID = item.invoice_no;
                  invoice_data.V_ID = item.v_id;
                  invoice_data.Date = item.date;
                  invoice_data.Cloud_Date = moment(
                    item.date + " " + item.time
                  ).format("DD MMM YYYY HH:mm A");
                  invoice_data.Transaction_Sub_Type = "sales";
                  invoice_data.Transaction_Type = "sales";
                  invoice_data.Status = "Success";
                  invoice_data.Store_ID = item.store_id;
                  invoice_data.Store_Name =
                    store.state.system.settings.store.name;
                  invoice_data.Location =
                    store.state.system.settings.store.location;
                  qty += item.weight_flag == true ? 1 : parseInt(item.qty);
                  paymentId = JSON.parse(item.payment_id);
                  customerId = item.user_id;
                });
              await db.payment
                .where("id")
                .anyOf(paymentId)
                .each((item) => {
                  mopList.push(item.type.name);
                });
              invoice_data.MOP = mopList.join(",");

              await db.customer.get(customerId, (customer) => {
                if (customer != undefined) {
                  invoice_data.Customer_Name =
                    customer.first_name + " " + customer.last_name;
                  invoice_data.mobile = customer.mobile;
                }
              });
              // console.log(getData);
              invoice_data.Amount = total.toFixed(2);
              invoice_data.Qty = qty;
              invoiceList.push(invoice_data);
            });
        }
      }
    )
      .then(() => {
        response.data.data = _.reverse(_.sortBy(invoiceList, ["OD_ID"]));
        response.data.pagination = {
          last_page:
            totalOrders.length <= 10 ? 1 : Math.ceil(totalOrders / perPage),
          total_records: totalOrders,
          per_page: perPage,
        };
      })
      .then(() => {
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "invoice_history",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const offlineSearch = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Invoice Search");

    let invoiceList = [];
    let perPage = 10;
    let totalOrder = 0;

    let response = {
      data: {},
    };
    db.transaction(
      "r",
      db.order,
      db.invoice,
      db.payment,
      db.customer,
      async () => {
        let search_invoices = [];
        let name_mobile = [];
        let pagination = {
          to: 0,
          from: 0,
        };

        await db.customer
          .orderBy("id")
          .and((filter) => {
            return (
              filter.first_name
                .toLowerCase()
                .indexOf(data.search_term.toString().toLowerCase()) != -1 ||
              filter.last_name
                .toLowerCase()
                .indexOf(data.search_term.toString().toLowerCase()) != -1
            );
          })
          .each((item) => {
            if (item != undefined) {
              name_mobile.push(item.mobile);
            }
          });

        if (name_mobile.length != 0) {
          await db.invoice
            .where("cust_mobile")
            .anyOf(name_mobile)
            .each((item) => {
              if (item != undefined) {
                search_invoices.push(item.order_id);
              }
            });
        } else {
          await db.invoice
            .orderBy("id")
            .and((filter) => {
              return (
                filter.invoice_no
                  .toLowerCase()
                  .indexOf(data.search_term.toString().toLowerCase()) != -1 ||
                filter.order_id
                  .toLowerCase()
                  .indexOf(data.search_term.toString().toLowerCase()) != -1 ||
                filter.cust_mobile.indexOf(data.search_term.toString()) != -1
              );
            })
            .each((item) => {
              if (item != undefined) {
                search_invoices.push(item.order_id);
              }
            });
        }

        search_invoices = _.sortedUniq(search_invoices);
        search_invoices = _.reverse(_.sortBy(search_invoices));
        totalOrder = search_invoices.length;

        if (data.page == 1) {
          pagination.to = 0;
        }
        search_invoices = _.slice(
          search_invoices,
          data.page * perPage - perPage,
          data.page * perPage
        );

        await db.order
          .where("order_id")
          .anyOf(search_invoices)
          .reverse()
          .each(async (order) => {
            let invoiceId = "";
            let invoice_data = {};
            let paymentId = [];
            let mopList = [];
            let customerId = 0;
            let total = 0;
            let qty = 0;

            invoiceId = JSON.parse(order.cart_id);
            invoice_data.OD_ID = order.id;
            await db.invoice
              .where("id")
              .anyOf(invoiceId)
              .each((item) => {
                total += parseFloat(item.total);
                invoice_data.Order_ID = item.invoice_no;
                invoice_data.V_ID = item.v_id;
                invoice_data.Date = item.date;
                invoice_data.Cloud_Date = moment(
                  item.date + " " + item.time
                ).format("DD MMM YYYY HH:mm A");
                invoice_data.Transaction_Sub_Type = "sales";
                invoice_data.Transaction_Type = "sales";
                invoice_data.Status = "Success";
                invoice_data.Store_ID = item.store_id;
                invoice_data.Store_Name =
                  store.state.system.settings.store.name;
                invoice_data.Location =
                  store.state.system.settings.store.location;
                qty += item.weight_flag == true ? 1 : parseInt(item.qty);
                paymentId = JSON.parse(item.payment_id);
                customerId = item.user_id;
              });
            await db.payment
              .where("id")
              .anyOf(paymentId)
              .each((item) => {
                mopList.push(item.type.name);
              });
            invoice_data.MOP = mopList.join(",");

            await db.customer.get(customerId, (customer) => {
              if (customer != undefined) {
                invoice_data.Customer_Name =
                  customer.first_name + " " + customer.last_name;
                invoice_data.mobile = customer.mobile;
              }
            });
            invoice_data.Amount = total.toFixed(2);
            invoice_data.Qty = qty;
            invoiceList.push(invoice_data);
          });
      }
    )
      .then(() => {
        response.data.data = _.reverse(_.sortBy(invoiceList, ["OD_ID"]));
        response.data.pagination = {
          last_page: Math.ceil(totalOrder / perPage),
          total_records: totalOrder,
          per_page: perPage,
        };
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "invoice_search",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

// export const offlineSearch = (data) => {
//   return new Promise((resolve, reject) => {
//     console.log("[OFFLINE]: Invoice Search");

//     let invoiceList = [];
//     let perPage = 10;
//     let totalOrder = 0;

//     let response = {
//       data: {},
//     };
//     db.transaction(
//       "r",
//       db.order,
//       db.invoice,
//       db.payment,
//       db.customer,
//       async () => {
//         let search_invoices = [];
//         let mobile = "";
//         let name_mobile = [];
//         let pagination = {
//           to: 0,
//           from: 0,
//         };

//         if (
//           _.isInteger(parseFloat(data.search_term)) &&
//           data.search_term.length ==
//             store.state.system.country_details.phone_digit
//         ) {
//           mobile = data.search_term;
//         }

//         if (_.isInteger(parseInt(data.search_term)) == false) {
//           await db.customer
//             .where("first_name")
//             .startsWithAnyOfIgnoreCase(data.search_term)
//             .or("last_name")
//             .startsWithAnyOfIgnoreCase(data.search_term)
//             .each((item) => {
//               console.log(item);
//               if (item != undefined) {
//                 name_mobile.push(item.mobile);
//               }
//             });
//         }

//         if (name_mobile.length != 0) {
//           // name_mobile.map(async (number) => {
//           await db.invoice
//             .where("cust_mobile")
//             .anyOf(name_mobile)
//             .each((item) => {
//               if (item != undefined) {
//                 search_invoices.push(item.order_id);
//               }
//             });
//           // });
//         } else {
//           await db.invoice
//             .where("invoice_no")
//             .anyOfIgnoreCase(data.search_term)
//             .or("order_id")
//             .anyOfIgnoreCase(data.search_term)
//             .or("cust_mobile")
//             .anyOfIgnoreCase(mobile)
//             .each((item) => {
//               if (item != undefined) {
//                 search_invoices.push(item.order_id);
//               }
//             });
//         }

//         search_invoices = _.sortedUniq(search_invoices);
//         search_invoices = _.reverse(_.sortBy(search_invoices));
//         totalOrder = search_invoices.length;

//         if (data.page == 1) {
//           pagination.to = 0;
//         }
//         search_invoices = _.slice(
//           search_invoices,
//           data.page * perPage - perPage,
//           data.page * perPage
//         );

//         await db.order
//           .where("order_id")
//           .anyOf(search_invoices)
//           .reverse()
//           .each(async (order) => {
//             let invoiceId = "";
//             let invoice_data = {};
//             let paymentId = [];
//             let mopList = [];
//             let customerId = 0;
//             let total = 0;
//             let qty = 0;

//             invoiceId = JSON.parse(order.cart_id);
//             invoice_data.OD_ID = order.id;
//             await db.invoice
//               .where("id")
//               .anyOf(invoiceId)
//               .each((item) => {
//                 total += parseFloat(item.total);
//                 invoice_data.Order_ID = item.invoice_no;
//                 invoice_data.V_ID = item.v_id;
//                 invoice_data.Date = item.date;
//                 invoice_data.Cloud_Date = moment(
//                   item.date + " " + item.time
//                 ).format("DD MMM YYYY HH:mm A");
//                 invoice_data.Transaction_Sub_Type = "sales";
//                 invoice_data.Transaction_Type = "sales";
//                 invoice_data.Status = "Success";
//                 invoice_data.Store_ID = item.store_id;
//                 invoice_data.Store_Name =
//                   store.state.system.settings.store.name;
//                 invoice_data.Location =
//                   store.state.system.settings.store.location;
//                 qty += item.weight_flag == true ? 1 : parseInt(item.qty);
//                 paymentId = JSON.parse(item.payment_id);
//                 customerId = item.user_id;
//               });
//             await db.payment
//               .where("id")
//               .anyOf(paymentId)
//               .each((item) => {
//                 mopList.push(item.type.name);
//               });
//             invoice_data.MOP = mopList.join(",");

//             await db.customer.get(customerId, (customer) => {
//               if (customer != undefined) {
//                 invoice_data.Customer_Name =
//                   customer.first_name + " " + customer.last_name;
//                 invoice_data.mobile = customer.mobile;
//               }
//             });
//             invoice_data.Amount = total.toFixed(2);
//             invoice_data.Qty = qty;
//             invoiceList.push(invoice_data);
//           });
//       }
//     )
//       .then(() => {
//         response.data.data = _.reverse(_.sortBy(invoiceList, ["OD_ID"]));
//         response.data.pagination = {
//           last_page: 1,
//           total_records: totalOrder,
//           per_page: perPage,
//         };
//         resolve(response);
//       })
//       .catch((err) => {
//         store.dispatch("system/log", {
//           type: "invoice_search",
//           log: { name: err.name, message: err.message },
//           response: err.stack,
//           status: "error",
//         });
//         alertData();
//         reject(response);
//       });
//   });
// };

export const orderDetails = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Order Details");
    let response = {
      data: {},
    };

    if (store.state.system.isOffline == false) {
      return Promise.resolve(response);
    }

    // let order_data = [];
    let customerId = 0;
    let paymentId = [];
    let bill_summary = [];
    let sub_total = 0.0;
    let total = 0.0;
    let manual_discount = 0;
    let tax_total = 0.0;
    let tax_inc = 0.0;
    let tax_exc = 0.0;
    let order_qty_total = 0;
    let mopList = [];
    let productData = [];
    let date = "";
    let time = "";
    let customer_data = {
      mobile: "",
      name: "",
    };

    db.transaction("rw", db.invoice, db.customer, db.payment, async () => {
      await db.invoice
        .where("invoice_no")
        .equals(data.order_id.toString())
        .each((orderItem) => {
          productData.push({
            cart_id: orderItem.id,
            product_data: {
              barcode: orderItem.barcode,
              p_name: orderItem.item_name,
              r_price: orderItem.subtotal,
              s_price: orderItem.total,
              discount: orderItem.discount,
              unit_mrp: orderItem.unit_mrp,
              // current_stock: 0,
              batch: [],
              uom: orderItem.uom,
              weight_flag: orderItem.weight_flag,
              offer: "No",
              offer_data: {
                applied_offers: [],
                available_offers: [],
              },
              multiple_price_flag: false,
              multiple_mrp: [orderItem.unit_mrp],
              images: "",
            },
            discount: 0,
            amount: orderItem.total,
            tax_amount: orderItem.tax,
            qty: orderItem.qty,
          });
          customerId = orderItem.user_id;
          paymentId = JSON.parse(orderItem.payment_id);
          orderItem.weight_flag == true
            ? (order_qty_total += 1)
            : (order_qty_total += parseInt(orderItem.qty));
          total += parseFloat(orderItem.total);
          sub_total += parseFloat(orderItem.subtotal);
          tax_total += parseFloat(orderItem.tax);
          tax_inc += orderItem.tax_data.tax_type == "INC" ? orderItem.tax : 0;
          tax_exc += orderItem.tax_data.tax_type == "EXC" ? orderItem.tax : 0;
          manual_discount += parseFloat(orderItem.md_discount);
          date = orderItem.date;
          time = orderItem.time;
        });
      await db.customer.get(customerId, (customer) => {
        customer_data.mobile = customer.mobile;
        customer_data.name = customer.first_name + " " + customer.last_name;
      });
      await db.payment
        .where("id")
        .anyOf(paymentId)
        .each((item) => {
          mopList.push(item.type.name);
        });
    })
      .then(() => {
        let man_disc = {
          name: "manual_discount",
          display_text: "Manual Discount",
          item_type: "",
          value: (Math.round(100 * manual_discount) / 100).toFixed(2),
          sign: "-",
        };

        bill_summary.push(
          {
            name: "sub_total",
            display_text: "Sub Total",
            item_type: "",
            value: (
              Math.round(100 * sub_total) / 100 -
              Math.round(100 * tax_inc) / 100
            ).toFixed(2),
            sign: "",
          },
          {
            name: "tax_total",
            display_text: "Tax",
            item_type: "",
            value: (Math.round(100 * tax_total) / 100).toFixed(2),
            sign: "",
          },
          {
            name: "total",
            display_text: "Total",
            item_type: "",
            value: (Math.round(100 * total) / 100).toFixed(2),
            sign: "",
          }
        );
        if (manual_discount != 0) {
          bill_summary.splice(1, 0, man_disc);
        }
      })
      .then(() => {
        response.data = {
          mobile: customer_data.mobile,
          customer_name: customer_data.name,
          status: "order_details",
          message: "Order Details Details",
          transaction_type: "sales",
          return_reasons: [],
          data: productData,
          return_req_process: [],
          return_req_approved: [],
          product_image_link:
            "https://test.vendor.gozwing.com/public/images/product/11/",
          store_header_logo:
            "https://test.vendor.gozwing.com/public/vendorstuff/store/logo/spar_logo_round.png",
          return_request_flag: false,
          bags: [],
          carry_bag_total: "0.00",
          sub_total: sub_total,
          tax_total: tax_total,
          tax_details: [],
          bill_buster_discount: "0.00",
          discount: "0.00",
          date: date,
          time: time,
          order_id: data.order_id,
          total: total,
          cart_qty_total: order_qty_total,
          saving: "0.00",
          store_address: store.state.system.settings.store.location,
          store_timings: " ",
          delivered: "No",
          address: {},
          user_api_token: "",
          payment_method: mopList.join(","),
          bill_remark: null,
          customer_group_code: "REGULAR",
          print_url:
            "https://test.api.gozwing.com/order-receipt/6434/11/25/Z1199551819C0003",
          c_id: customerId,
          bill_summary: bill_summary,
        };
      })
      .then(() => {
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "order_details",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const orderRecall = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Order Recall");
    let response = {
      data: {},
    };

    if (store.state.system.isOffline == false) {
      let config = JSON.parse(data.config.data);
      let cart_id = [];
      db.transaction("rw", db.order, db.cart, async () => {
        await db.order
          .where("online_order_id")
          .equals(config.order_id)
          .first((item) => {
            if (item != undefined) {
              cart_id = JSON.parse(item.cart_id);
            }
          });
        cart_id.map(async (item) => {
          if (item != undefined) {
            await db.cart.update(item, { status: "process" });
          }
        });
        await db.order
          .where("online_order_id")
          .equals(config.order_id)
          .delete();
      });
      return Promise.resolve(response);
    }

    let cart_id = [];
    let user_id = "";
    let cust_info = {};
    let session_id = store.state.sessions.session.id;
    db.transaction("rw", db.order, db.cart, db.customer, async () => {
      await db.order
        .where("order_id")
        .equals(data.order_id)
        .first(async (item) => {
          cart_id = JSON.parse(item.cart_id);
          cart_id.map(async (product) => {
            await db.cart.update(product, {
              status: "process",
              session_id: session_id,
            });
            await db.cart
              .where("id")
              .equals(product)
              .first((item) => {
                user_id = item.user_id;
              });
          });

          await db.order.delete(item.id);
        });
    })
      .then(async () => {
        if (
          user_id != parseInt(store.state.billing.billing.dumuy_customer.c_id)
        ) {
          cust_info = await db.customer.get(user_id);
        } else {
          cust_info.id = parseInt(
            store.state.billing.billing.dumuy_customer.c_id
          );
          cust_info.first_name = "Dummy";
          cust_info.last_name = "Customer";
          cust_info.mobile = "3200000011";
        }
        response.data = {
          status: "success",
          message: "Order Recall successfully",
          data: {
            c_id: cust_info.id,
            mobile: cust_info.mobile,
            // api_token: "0VdrUyVGLxbt3lVo4uGeRmEgWAP3Rphnora7Xf9r9BX1i6Y19d",
            first_name: cust_info.first_name,
            last_name: cust_info.last_name,
            groups: ["REGULAR"],
            // vendor_user_id: 152,
            email: cust_info.email,
            gender: cust_info.gender,
            gstin: cust_info.gst,
          },
          address: cust_info.address,
          group_settings: {
            items_limit_perbill: false,
            maximum_limit_perbill: 0,
            items_limit_perday: false,
            maximum_limit_perday: 0,
            value_limit_perbill: false,
            maximum_value_perbill: 0,
            value_limit_perday: false,
            maximum_value_perday: 0,
            allow_manual_discount_item_level: false,
            allow_manual_discount_bill_level: false,
            actual_maximum_limit_perday: 0,
            actual_maximum_value_perday: 0,
          },
        };
      })
      .then(() => {
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "order_recall",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

export const getPrintReceipt = (data) => {
  return new Promise((resolve, reject) => {
    console.log("[OFFLINE]: Get Print");
    let response = {
      data: {},
    };
    // const original_template =
    //   store.state.system.settings.vendor_app_menu.offline.invoice_format;
    // console.log(original_template);
    // const print_template = original_template;

    if (store.state.system.isOffline == false) {
      return Promise.resolve(response);
    }

    let invoice_no = data.order_id;
    let date_time = "";
    let info = {};
    let user_id = 0;
    let customer_mobile = "";
    let pdata = [];
    let tdata = [];
    let product_template_1 = [];
    let product_template_2 = [];
    let gst_template = [];
    let count = 0;
    let total_qty = 0;
    let total_amt = 0.0;
    let taxable_total = 0;
    let sgst_total = 0;
    let cgst_total = 0;
    let cess_total = 0;
    let total_discount = 0;
    let cool = "";
    let pay_id = [];
    let pay_methods = [];
    let pay_template = [];
    let template = [];
    let cash_collected = 0;
    let balance_refund = 0;

    template.push(
      store.state.system.settings.vendor_app_menu.offline.invoice_format
    );
    template[0].map((item) => {
      if (item.key == "item_detail_1") {
        // item.text.map(key => {
        product_template_1 = item;
        // });
      } else if (item.key == "item_detail_2") {
        product_template_2 = item;
      } else if (item.key == "gst_listing") {
        gst_template = item;
      } else if (item.key == "mop") {
        pay_template = item.text;
      }
    });

    db.transaction("rw", db.invoice, db.customer, db.payment, async () => {
      await db.invoice
        .where("invoice_no")
        .equals(invoice_no)
        .first((item) => {
          user_id = item.user_id;
          date_time = item.date + " at " + item.time;
          pay_id = item.payment_id;
        });
      await db.customer
        .where("id")
        .equals(user_id)
        .first((customer) => {
          customer_mobile = customer.mobile;
        });
      const invoiceData = await db.invoice
        .where("invoice_no")
        .equals(invoice_no)
        .toArray();

      invoiceData.map((invoice) => {
        if (invoice.uom == "Weight") {
          total_qty += 1;
        } else {
          total_qty += parseInt(invoice.qty);
        }
        total_amt += parseFloat(invoice.total);
        if (invoice.tax_data.tax_name != "GST 0%") {
          taxable_total += parseFloat(invoice.tax_data.taxable);
        }
        cgst_total += parseFloat(invoice.tax_data.cgstamt);
        sgst_total += parseFloat(invoice.tax_data.sgstamt);
        cess_total += parseFloat(invoice.tax_data.cessamt);
        total_discount += parseFloat(invoice.discount);
        // let data = {};
        count += 1;
        let detail_1 = getFirstDataFromKey(product_template_1, invoice, count);
        let detail_2 = getSecondDataFromKey(product_template_2, invoice);
        pdata.push({ detail_1, detail_2 });

        let TaxData = [];
        if (invoiceData.length == 1 && invoice.tax_data.tax_name == "GST 0%") {
          TaxData = getTaxData(gst_template, invoice);
        } else {
          if (tdata.length == 0) {
            if (invoice.tax_data.tax_name != "GST 0%") {
              TaxData = getTaxData(gst_template, invoice);
            }
          } else if (
            tdata.length > 0 &&
            invoice.tax_data.tax_name != "GST 0%"
          ) {
            let present = false;
            tdata.map((tax) => {
              tax.map((item) => {
                if (item.name == invoice.tax_data.tax_name) {
                  present = true;
                } else if (item.key == "gst_taxable" && present == true) {
                  item.name =
                    parseFloat(item.name) +
                    parseFloat(invoice.tax_data.taxable);
                } else if (item.key == "gst_cgst" && present == true) {
                  item.name =
                    parseFloat(item.name) +
                    parseFloat(invoice.tax_data.cgstamt);
                } else if (item.key == "gst_sgst" && present == true) {
                  item.name =
                    parseFloat(item.name) +
                    parseFloat(invoice.tax_data.sgstamt);
                } else if (item.key == "gst_cess" && present == true) {
                  item.name =
                    parseFloat(item.name) +
                    parseFloat(invoice.tax_data.cessamt);
                }
              });
            });
            if (present == false) {
              TaxData = getTaxData(gst_template, invoice);
            }
          }
        }

        tdata.push(TaxData);
      });
      pay_id = JSON.parse(pay_id);
      pay_id.map(async (item) => {
        let data = {};
        await db.payment
          .where("id")
          .equals(item)
          .first((method) => {
            if (method.type.name == "CASH") {
              cash_collected += parseFloat(method.type.cash_collected);
              balance_refund += parseFloat(method.type.balance_refund);
            }
            data = method;
          });
        let getMethods = getPayMethods(pay_template, data);
        pay_methods.push(getMethods);
      });
    })
      .then(() => {
        let gst_total = {
          taxable: taxable_total.toFixed(2),
          cgstamt: cgst_total.toFixed(2),
          sgstamt: sgst_total.toFixed(2),
          cessamt: cess_total.toFixed(2),
        };
        info = {
          date_time: date_time,
          cashier_name:
            store.state.sessions.user.first_name +
            " " +
            store.state.sessions.user.last_name,
          cust_mob: customer_mobile,
          pdata: pdata,
          qty: total_qty,
          total: total_amt.toFixed(2),
          amount_words: convertToWords(total_amt),
          tdata: tdata,
          gst_total: gst_total,
          total_discount: total_discount.toFixed(2),
          mop: pay_methods,
          cash_collected: cash_collected,
          balance_refund: balance_refund,
        };
      })
      .then(() => {
        cool = printer.htmlOutput(
          data.order_id,
          store.state.system.settings.vendor_app_menu.offline.invoice_format,
          info
        );
      })
      .then(() => {
        response.data.print_data = cool;
      })
      .then(() => {
        resolve(response);
      })
      .catch((err) => {
        store.dispatch("system/log", {
          type: "get_print",
          log: { name: err.name, message: err.message },
          response: err.stack,
          status: "error",
        });
        alertData();
        reject(response);
      });
  });
};

function getFirstDataFromKey(temp, invoice, count) {
  let returnData = temp.text.filter((item) => {
    if (item.key == "sr_no") {
      item.name = count;
    }
    if (item.key == "name") {
      item.name = invoice.item_name.substring(0, item.length);
    }
    if (item.key == "rate") {
      item.name = invoice.total;
    }
    if (item.key == "qty") {
      item.name = invoice.qty;
    }
    if (item.key == "tax_amt") {
      item.name = invoice.tax;
    }
    if (item.key == "total") {
      item.name = invoice.total;
    }
    return true;
  });
  return JSON.parse(JSON.stringify(returnData));
}

function getSecondDataFromKey(temp, invoice) {
  let returnData = temp.text.filter((item) => {
    if (item.key == "item_code") {
      item.name = invoice.barcode.substring(0, item.length);
    } else if (item.key == "hsn") {
      item.name = invoice.tax_data.hsn;
    } else if (item.key == "discount") {
      item.name = invoice.discount;
    }
    return true;
  });
  return JSON.parse(JSON.stringify(returnData));
}

function getTaxData(temp, invoice) {
  let returnData = temp.text.filter((item) => {
    if (item.key == "gst_name") {
      item.name = invoice.tax_data.tax_name;
    } else if (item.key == "gst_taxable") {
      item.name = parseFloat(invoice.tax_data.taxable).toFixed(2);
    } else if (item.key == "gst_cgst") {
      item.name = parseFloat(invoice.tax_data.cgstamt).toFixed(2);
    } else if (item.key == "gst_sgst") {
      item.name = parseFloat(invoice.tax_data.sgstamt).toFixed(2);
    } else if (item.key == "gst_cess") {
      // if (invoice.tax_data.cess != 0) {
      item.name = parseFloat(invoice.tax_data.cessamt).toFixed(2);
      // }
    }
    return true;
  });
  return JSON.parse(JSON.stringify(returnData));
}

function getPayMethods(temp, data) {
  temp.textLeft = data.type.name;
  temp.textRight = data.amount.toFixed(2);

  return JSON.parse(JSON.stringify(temp));
}

export const printAcknowledgement = (data) => {
  // return new Promise((resolve, reject) => {
  console.log("[OFFLINE]: Print Acknowledgement");
  // let response = {
  //   data: {},
  // };
  console.log(data);

  // console.log(print_template);
  // });
};

function convertToWords(amount) {
  var words = new Array();
  words[0] = "";
  words[1] = "One";
  words[2] = "Two";
  words[3] = "Three";
  words[4] = "Four";
  words[5] = "Five";
  words[6] = "Six";
  words[7] = "Seven";
  words[8] = "Eight";
  words[9] = "Nine";
  words[10] = "Ten";
  words[11] = "Eleven";
  words[12] = "Twelve";
  words[13] = "Thirteen";
  words[14] = "Fourteen";
  words[15] = "Fifteen";
  words[16] = "Sixteen";
  words[17] = "Seventeen";
  words[18] = "Eighteen";
  words[19] = "Nineteen";
  words[20] = "Twenty";
  words[30] = "Thirty";
  words[40] = "Forty";
  words[50] = "Fifty";
  words[60] = "Sixty";
  words[70] = "Seventy";
  words[80] = "Eighty";
  words[90] = "Ninety";
  amount = amount.toString();
  var atemp = amount.split(".");
  var number = atemp[0].split(",").join("");
  var n_length = number.length;
  var words_string = "";
  if (n_length <= 9) {
    var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
    var received_n_array = new Array();
    for (let i = 0; i < n_length; i++) {
      received_n_array[i] = number.substr(i, 1);
    }
    for (let i = 9 - n_length, j = 0; i < 9; i++, j++) {
      n_array[i] = received_n_array[j];
    }
    for (let i = 0, j = 1; i < 9; i++, j++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        if (n_array[i] == 1) {
          n_array[j] = 10 + parseInt(n_array[j]);
          n_array[i] = 0;
        }
      }
    }
    let value = "";
    for (let i = 0; i < 9; i++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        value = n_array[i] * 10;
      } else {
        value = n_array[i];
      }
      if (value != 0) {
        words_string += words[value] + " ";
      }
      if (
        (i == 1 && value != 0) ||
        (i == 0 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Crores ";
      }
      if (
        (i == 3 && value != 0) ||
        (i == 2 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Lakhs ";
      }
      if (
        (i == 5 && value != 0) ||
        (i == 4 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Thousand ";
      }
      if (i == 6 && value != 0 && n_array[i + 1] != 0 && n_array[i + 2] != 0) {
        words_string += "Hundred and ";
      } else if (i == 6 && value != 0) {
        words_string += "Hundred ";
      }
    }
    words_string = words_string.split("  ").join(" ");
  }
  return words_string;
}

function alertData() {
  let alertData = {
    message: msg.INTERNAL_SERVER_ERROR,
    type: "danger",
  };
  store.commit("notifications/showAlert", alertData);
}
